"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGuard = void 0;
const react_1 = require("react");
const context_1 = require("./context");
const useGuard = () => {
    const { guard } = (0, react_1.useContext)(context_1.GuardContext);
    const { resourceName } = (0, react_1.useContext)(context_1.GuardResourceContext);
    const canAction = (0, react_1.useCallback)((action, specifiedResourceName) => {
        const protectedResourceName = specifiedResourceName || resourceName;
        if (!protectedResourceName) {
            throw new Error('useGuard error: you must defined resourceName as argument or by context');
        }
        return guard.can(protectedResourceName, action);
    }, [guard, resourceName]);
    return (0, react_1.useMemo)(() => {
        return {
            canAction
        };
    }, [canAction]);
};
exports.useGuard = useGuard;
//# sourceMappingURL=hooks.js.map